import React from "react"
import {Button} from "@mui/material";
import {Chat, LanguageCode, Profile} from "../../models";
import {VideoFormDialog} from "../../content/components/VideoFormDialog";
import {VideoAdFormDialog} from "../../content/components/VideoAdFormDialog";
import Edit from "../../content/edit";
import GmailEdit from "../../content/components/gmailEdit";

type EditType = | "content" | "stim" | "story" | "watch" | "watchStim" | "reel" | "reelStim" | "video" | "videoStim" | "music" | "musicStim" | "gmail" | "yt" | "ytStim";

interface PersonaContentEditProps {
    editId: number;
    editType: EditType;
    languageCodes: LanguageCode[];
    profiles: Profile[];
    chats: Chat[];
    onClose: () => void;
    onSave: () => void;
}

export const PersonaContentEdit: React.FC<PersonaContentEditProps> = ({ editId, editType, languageCodes, profiles, chats, onClose, onSave }) => {

    switch (editType) {
        case "content":
        case "stim":
        case "story":
        case "watch":
        case "watchStim":
        case "reel":
        case "reelStim":
        case "video":
        case "videoStim":
        case "music":
        case "musicStim":
            return <div className="edit-item-container">
                <Edit
                    id={editId}
                    type={editType}
                    close={onClose}
                />
            </div>

        case "gmail":
            return <div className="edit-item-container">
                <GmailEdit
                    id={editId}
                    type={editType}
                    close={onClose}
                />
            </div>

        case "yt":
            return  <VideoFormDialog
                videoId={editId}
                languageCodes={languageCodes!}
                profiles={profiles!}
                chats={chats!}
                onClose={onClose}
                onVideoSave={onSave}
            />

        case "ytStim":
            return <VideoAdFormDialog
                videoAdId={editId}
                languageCodes={languageCodes!}
                profiles={profiles!}
                onClose={onClose}
                onVideoAdSave={onSave}
            />

        default: {
            // Keeps TS happy if EditType changes later.
            return (
                <div>
                    <div>Unsupported edit type: {editType}</div>
                    <Button onClick={onClose} variant="outlined">
                        Close
                    </Button>
                </div>
            );
        }
    }
}
